(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-fw26-slider"] && !Shopify.designMode) return;
  try {
    
  if (typeof window.dAgency != 'undefined' && dAgency.section_js != undefined) {
    for (const element in dAgency.section_js) {
      if (Object.hasOwnProperty.call(dAgency.section_js, element)) {
        const src = dAgency.section_js[element];
        var s = document.createElement('script');
        s.setAttribute('id', element.trim('.js'));
        s.setAttribute('src', src);
        s.setAttribute('defer', 'defer');
        document.body.appendChild(s);
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
